module.exports = __webpack_public_path__ + "static/media/red_cross.70a2229f.svg";